// JS agregar productos al carrito de compras desde product card

$(document).ready(function(){
    // variantes
    let id
    let qty = 1

    // acciones
    $('body').on('click', '.js-product-add__action', function(event) {
	    productAddSwitch($(this))
      	productAdd($(this))
    })

    // funciones
    function productAdd(action) {
        id = action.data('product-add__id')

        $.ajax({
            url: "/cart/add",
            type: "post",
            data: {
                id: id,
                quantity: qty
            },
            dataType: 'json',
            async: true,
            success:  res => {
                localStorage.setItem('atom_product', JSON.stringify(res))

                if ( action.data('product-add__checkout') ) {
                    window.location = '/cart'
                }

            },
            error: err => {
                console.log(err)
            }
        })

    }

    function productAddSwitch(action) {
        $('.js-product-add__text').each( function (){
            if ( action.data('product-add__id') == $(this).data('product-add__id') ) {
                $(this).html( $(this).data('product-add__pass-1') )
                setTimeout(() => {
                    $(this).html( $(this).data('product-add__pass-2') )
                }, 1500)
            }
        })
    }
})